import React from 'react';
import { Switch, ISwitchProps } from '@blueprintjs/core';
import { TranslatedMessage } from '../../translation';
import { Overwrite } from '../../../../typings/typings';
import { TLCode } from '../../../../common/enums';
import styled from '@emotion/styled';

const ContainerSwitch = styled.div`
  display: flex;
  flex-direction: row;
  `;

// tslint:disable-next-line:no-empty-interface
interface CommonSwitchInputProps extends ISwitchProps {
}

export type SwitchInputProps = Overwrite<CommonSwitchInputProps, { label?: TLCode }>;

const renderSwitch = (props: ISwitchProps) => <Switch {...props} />;

const SwitchInput = ({ label, ...otherProps }: SwitchInputProps) => {
  if (label !== undefined) {
    const sw = renderSwitch({ ...otherProps });
    return (
      <ContainerSwitch>
        <b><TranslatedMessage id={label}/></b>
        {sw}
      </ContainerSwitch>
    );
  } else {
    return renderSwitch({ ...otherProps });
  }
};

export default SwitchInput;
